import PropTypes from 'prop-types';
import useProposalTypes from 'apps/proposals/hooks/use-proposal-types';
import { AdvancedCombobox, Button, Icon } from '@evertrue/et-components';

const ProposalTypeField = ({ onChange, onBlur, name = '', value = '', required = false, field, meta, helpers }) => {
  const [proposalTypes = []] = useProposalTypes();

  return (
    <div className="proposal-form--cancel-wrapper">
      <AdvancedCombobox
        className="proposal-form--form-field-dropdown"
        disabled={!proposalTypes.length}
        label={value ? value + ' selected' : 'Select proposal type'}
        value={proposalTypes.find((type) => type.value === value)}
        options={proposalTypes}
        placeholder={proposalTypes.length ? 'Select a proposal type...' : 'No types configured'}
        onChange={(selected) => {
          helpers.setValue(selected?.value);
        }}
        onClose={() => {
          helpers.setTouched(true, false);
        }}
      />
      {value && (
        <Button type="simple" onClick={() => helpers.setValue(null)} label="Remove proposal type">
          <Icon icon="cancel" className="proposal-form--cancel" title="Remove proposal type" size={1} />
        </Button>
      )}
    </div>
  );
};

ProposalTypeField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default ProposalTypeField;
